/**
 * 지금 화면이 TIM_BOX 설치 앱 안에서 떠 있는지.
 *
 * 윈도우 앱(Electron)은 미리 붙여 둔 `window.timbox` 다리가 있고, 안드로이드 앱은
 * 시스템 WebView 라 사용자 에이전트에 `; wv)` 가 붙는다. 앱 안에서 "앱 받기" 를
 * 보여 줄 이유는 없으므로 이걸로 가린다.
 */
export function isInsideTimboxApp(): boolean {
  try {
    if ((window as unknown as { timbox?: unknown }).timbox) return true;
    return /;\s*wv\)/i.test(navigator.userAgent || "");
  } catch {
    return false;
  }
}

/** 공개 다운로드 페이지(로그인 없이 열린다). nginx 가 /api/v1/app/ 으로 넘긴다. */
export const APP_INSTALL_URL = "/install";
